<template>
  <el-form
    ref="form"
    @submit.prevent.native="$emit('submit')"
    :disabled="disabled"
    :label-width="labelWidth"
  >
    <slot name="navbar"></slot>
    <el-row :gutter="20">
      <el-col class="box-wrapper" :span="15" :lg="{ span: 18 }">
        <div class="box">
          <slot name="box"></slot>
        </div>
      </el-col>
      <el-col :span="9" :lg="{ span: 6 }" class="sidebar">
        <slot name="sidebar"></slot>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    labelWidth: {
      type: String,
      default: '100px'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  border: 0;
}
.sidebar {
  position: sticky;
  top: 80px;
}
</style>
